import Entities from 'STORE';
import { IPushNotification } from 'STORE/PushNotifications/PushNotifications.types';

import { alreadyReadMessage } from '../utils/alreadyReadMessage';
import { isInActiveChat } from '../utils/isInActiveChat';
import { onGroupNotificationClick } from '../utils/onGroupNotificationClick';
import { onNotificationClose } from '../utils/onNotificationClose';
import { prepareNotificationOptions } from '../utils/prepareNotificationOptions';
import { prepareNotificationTitle } from '../utils/prepareNotificationTitle';

export const handleDefaultNotification = (pushNotification: IPushNotification): void => {
  if (
    isInActiveChat(pushNotification) ||
    alreadyReadMessage(pushNotification) ||
    !pushNotification.group
  ) {
    return;
  }

  const notification = new Notification(
    prepareNotificationTitle(pushNotification),
    prepareNotificationOptions(pushNotification)
  );

  Entities.pushNotifications.addNotification(notification);
  notification.onclose = (): void => onNotificationClose(notification);
  notification.onerror = (): void => onNotificationClose(notification);
  notification.onclick = (): Promise<void> =>
    onGroupNotificationClick(pushNotification, notification);
};
